type IErrorCode = "unknown";

export class FacebookCommerceRepoError extends Error {
  public readonly code: IErrorCode;
  public readonly cause?: unknown;
  public readonly repo: string;

  constructor(
    repo: string,
    message: string,
    code: IErrorCode,
    cause?: unknown
  ) {
    super(message);

    this.name = "FacebookCommerceRepoError";
    this.repo = repo;
    this.message = message;
    this.code = code;
    this.cause = cause;
  }
}
